export default "__VITE_ASSET__DAO16leU__"